import React, { useCallback } from "react";
import { formatRelationType } from "utilities";

import { isGenerationalRelationType } from "./entityFormConfigs";
import type { RelationDraft } from "./entityForms.types";
import LineIcon from "./LineIcon";

import styles from "./RelationChipItem.module.css";

type RelationChipItemProps = {
	onRemove: (id: string) => void;
	relation: RelationDraft;
	removeLabel: string;
};

/** Chip for one relation/connection/association draft: "<Type>: <target>" with a remove button. */
const RelationChipItem = ({ onRemove, relation, removeLabel }: RelationChipItemProps) => {
	const onRemoveClick = useCallback((): void => onRemove(relation.id), [onRemove, relation.id]);
	// "Father: Arpita" reads "Arpita is the Father"; a reversed generational draft ("this person is
	// the Father of Arpita") renders as "Father of: Arpita" so the chip keeps the true direction.
	const isReversedGenerational =
		relation.direction === "toTarget" && isGenerationalRelationType(relation.relationType);

	return (
		<span className={styles.relationChip}>
			<strong>
				{formatRelationType(relation.relationType, relation.isEx)}
				{isReversedGenerational ? " of" : ""}:
			</strong>{" "}
			{relation.targetTitle}
			<button
				aria-label={removeLabel}
				className={styles.relationChipRemove}
				onClick={onRemoveClick}
				type="button">
				<LineIcon name="close" />
			</button>
		</span>
	);
};

export default RelationChipItem;
